import { Component, OnInit, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { EventDialogComponent } from '../event-dialog/event-dialog.component';
import { EventDialogResult } from '../event-dialog/event-dialog.component';
import { AuthenticationService } from '../services/authentication.service';
import { InterestOptions } from 'src/shared/constants/interestOptions';
import { AdminService } from '../services/admin.service';
import { OrganizationService } from '../services/organization.service';
import { UserService } from '../services/user.service';
import { EventsListComponent } from '../events-list/events-list.component';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.css', '../../shared/styles/formStyles.css']
})
export class HomepageComponent implements OnInit {
  @ViewChild(EventsListComponent) eventsList!: EventsListComponent;

  downloadURL: any;
  categories: String[] = [];
  interestOptions: { [key: string]: string } = InterestOptions;
  interestKeys: string[] = Object.keys(this.interestOptions);
  interests: string[] | undefined;

  public isUser = false;
  public isOrg = false;
  public isAdmin = false;


  constructor(
    private dialog: MatDialog,
    private authService: AuthenticationService,
    private adminService: AdminService,
    private orgService: OrganizationService,
    private userService: UserService) { }

  ngOnInit() {
    this.authService.setSignedIn(true);

    setTimeout(() => this.authService.CheckPrivileges(), 1000);
    setTimeout(() => this.isAdmin = this.adminService.getAdminStatus(), 2000);
    setTimeout(() => this.isUser = this.userService.getUserStatus(), 2000);
    setTimeout(() => this.isOrg = this.orgService.getOrgStatus(), 2000);

    setTimeout(() => console.log(this.isAdmin, this.isUser, this.isOrg), 3000);
  }

  ngAfterViewInit() {
    this.refreshEvents();
  }

  onCheckChange(events1: Event, key: string) {
    if (!events1.target) return;

    this.interests = this.interests ?? [];

    if ((events1.target as HTMLInputElement).checked) {
      this.interests.push(key);
    } else {
      const index = this.interests.indexOf(key, 0) ?? -1;
      if (index > -1) {
        this.interests.splice(index, 1);
      }
    }
  }

  refreshEvents(): void {
    this.eventsList.refreshEvents(undefined, this.interests)
  }

  newEvent(): void {
    const dialogRef = this.dialog.open(EventDialogComponent, {
      width: '300px',
      data: {
        event: {},
      },
    });

    dialogRef
      .afterClosed()
      .subscribe((result: EventDialogResult | undefined) => {
        if (!result) {
          return;
        }
        this.refreshEvents();
      })
  }
}
